import {
	createContext,
	default as React,
	type ReactNode,
	useContext,
} from "react";
import { useComplexState } from "use-complex-state";
import { ShelvesReducer } from "../reducers/ShelvesReducer";

const ShelvesContext = createContext({
	state: ShelvesReducer.getInitialState(),
	actions: ShelvesReducer.actions,
});

export const useShelvesContext = () => useContext(ShelvesContext);

export const ShelvesProvider = ({ children }: { children: ReactNode }) => {
	const [state, actions] = useComplexState({
		initialState: ShelvesReducer.getInitialState(),
		reducers: ShelvesReducer.caseReducers,
	});

	return (
		<ShelvesContext.Provider value={{ state, actions }}>
			{children}
		</ShelvesContext.Provider>
	);
};
